function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScStar = function SvgScStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "m14.257 8.59.233.6.643.037 4.69.26c.66.037 1.088.062 1.388.105l.068.01-.049.049c-.217.211-.55.483-1.062.9l-3.64 2.968-.5.407.165.624 1.201 4.54c.17.64.278 1.054.33 1.353l.01.067a2.682 2.682 0 0 1-.06-.03c-.269-.142-.63-.374-1.185-.732l-3.947-2.545-.542-.35-.542.35-3.947 2.545c-.556.358-.916.59-1.185.731a2.706 2.706 0 0 1-.06.032c.002-.021.006-.044.01-.068.052-.299.16-.714.33-1.353l1.2-4.54.166-.624-.5-.407-3.64-2.967c-.513-.418-.845-.69-1.062-.901a2.818 2.818 0 0 1-.049-.048c.02-.004.043-.007.068-.01.3-.044.728-.069 1.388-.105l4.69-.261.643-.036.233-.601 1.698-4.38c.239-.616.394-1.015.528-1.288l.031-.06.03.06c.135.273.29.672.53 1.289l1.697 4.379Z",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScStar;